"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('Form'), recompose_1.pure);
exports.Form = enhance(function (_a) {
    var className = _a.className, children = _a.children, onSubmit = _a.onSubmit;
    return (React.createElement("div", { className: classNames('sok-form', className) },
        React.createElement("form", { encType: 'multipart/form-data', method: 'POST', onSubmit: function (e) {
                e.preventDefault();
                var keys = new Array(e.target.elements.length);
                var elements = keys.map(function (_, i) { return e.target.elements[i]; });
                var obj = elements.reduce(function (acc, element) {
                    acc[element.name] = element.value;
                    return acc;
                }, {});
                onSubmit(obj);
                return false;
            } }, children)));
});
//# sourceMappingURL=index.js.map